var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_2099238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4136 18.4899C19.1298 18.4899 18.8835 18.2848 18.8361 18.0003C18.4133 15.5314 16.0226 11.2225 9.95832 10.9707V14.1384C9.95832 14.3579 9.83566 14.559 9.64051 14.6594C9.44531 14.7598 9.21039 14.7427 9.0318 14.6152L0.245352 8.33911C0.0913672 8.22911 0 8.05149 0 7.86227C0 7.67301 0.0913672 7.49544 0.245352 7.38548L9.03184 1.10946C9.21039 0.981882 9.44535 0.964811 9.64051 1.06524C9.83566 1.16567 9.95832 1.36676 9.95832 1.58626V4.80169C13.7069 5.17559 20 7.88137 20 17.904C20 18.2088 19.7662 18.4628 19.4624 18.4879C19.446 18.4892 19.4297 18.4899 19.4136 18.4899Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back_btn.076132ca7e0e4fa9ca8c7ba040f1ae38.svg";
export { ForwardRef as ReactComponent };